import { type Photo, type Video } from '@/infra/services/catalog/review/model';

import { type MediaItem } from '../Medias';

const buildMediaItems = (photos: Photo[], videos: Video[]) => {
  const items = [
    ...videos
      .filter((video) => video.host === 'www.youtube.com')
      .map<MediaItem>(({ id: videoId }, index) => ({
        thumbSrc: `http://img.youtube.com/vi/${videoId}/mqdefault.jpg`,
        type: 'video',
        alt: `Vídeo ${index + 1}`,
        videoId,
      })),
    ...photos.map<MediaItem>(({ normal: thumbSrc }, index) => ({
      thumbSrc,
      type: 'photo',
      alt: `Foto ${index + 1}`,
    })),
  ];

  return items;
};

export default buildMediaItems;
